import { render, staticRenderFns } from "./DeliveryNotification.vue?vue&type=template&id=55d18c34&"
import script from "./DeliveryNotification.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports